export default "__VITE_ASSET__Cjd9FAUW__"